import { Row, Button, Skeleton, Card, Typography } from "antd";
import AlternativeLogo from "components/AlternativeLogo/AlternativeLogo";
import CompanyLogo from "components/CompanyLogo/CompanyLogo";
import RelevantStudyYearsDisplay from "components/RelevantStudyYearsDisplay/RelevantStudyYearsDisplay";
import { useHistory } from "react-router-dom";
import { JOB_TYPE_DESCRIPTIONS } from "constants/jobTypes";
import { ContactPerson, JobPosting } from "containers/SingleJobPosting/interfaces";
import React from "react";
import dayjs from "dayjs";
import { StyledText, StyledWrapper, StyledLogoCard } from "./style";

const { Text } = Typography;

export interface Props {
  companyId?: number;
  imageLink?: string;
  job: JobPosting | undefined;
  contactPerson?: ContactPerson;
}

const JobDescription: React.FC<Props> = ({ companyId, imageLink, job, contactPerson }) => {
  const openInNewTab = (url: string) => {
    window.open(url, "_blank")?.focus();
  };

  const history = useHistory();

  return (
    <>
      <Card bodyStyle={{ padding: "2em" }}>
        <Row justify="center" style={{ paddingBottom: "2em" }}>
          {imageLink && companyId ? (
            <StyledLogoCard bordered={false} onClick={() => history.push(`/companies/${companyId}`)}>
              {job?.alt_logo ? (
                <AlternativeLogo size="90%" src={job.alt_logo} />
              ) : (
                <CompanyLogo size="90%" companyId={companyId} src={imageLink} />
              )}
            </StyledLogoCard>
          ) : (
            <>
              <StyledWrapper>
                <Skeleton.Image />
              </StyledWrapper>
            </>
          )}
        </Row>
        <Row>
          <StyledText>
            <b>Stillingstype</b>
          </StyledText>
        </Row>
        <Row style={{ paddingBottom: "1em" }}>
          {(job?.job_type as string) ? (
            <StyledText>
              {JOB_TYPE_DESCRIPTIONS.find(type => type.value === job?.job_type)?.label || job?.job_type}
            </StyledText>
          ) : (
            <Skeleton.Button active style={{ height: "1.1em" }} />
          )}
        </Row>
        <Row>
          <StyledText>
            <b>Sted</b>
          </StyledText>
        </Row>
        <Row style={{ paddingBottom: "1em" }}>
          {job?.location ? (
            <StyledText>{job.location}</StyledText>
          ) : (
            <Skeleton.Button active style={{ height: "1.1em" }} />
          )}
        </Row>
        <Row>
          <StyledText>
            <b>Søknadsfrist</b>
          </StyledText>
        </Row>
        <Row style={{ paddingBottom: "1em" }}>
          {job?.deadline ? (
            <StyledText>{dayjs(job.deadline).format("DD.MM.YYYY")}</StyledText>
          ) : (
            <Skeleton.Button active style={{ height: "1.1em" }} />
          )}
        </Row>
        <Row>
          <StyledText>
            <b>Årstrinn</b>
          </StyledText>
        </Row>
        <Row style={{ paddingBottom: "1em" }}>
          {job?.year_levels ? (
            <RelevantStudyYearsDisplay yearLevelsAccepted={job.year_levels} />
          ) : (
            <Skeleton.Button active style={{ height: "1.1em" }} />
          )}
        </Row>
        <Row>
          <StyledText>
            <b>Kontaktperson</b>
          </StyledText>
        </Row>

        <Row style={{ paddingBottom: "0.6em" }}>
          {contactPerson ? (
            <StyledText>
              <a href={`mailto:${contactPerson.email}`}>{`${contactPerson.first_name} ${contactPerson.last_name}`}</a>
            </StyledText>
          ) : (
            <Text italic>Ikke bestemt</Text>
          )}
        </Row>
        {job?.search_url && (
          <Row justify="center" style={{ paddingBottom: "0.6em", paddingTop: "0.9em" }}>
            <Button
              size="large"
              type="primary"
              style={{ background: "@primary-color", border: "none", width: "100%" }}
              onClick={() => {
                openInNewTab(job.search_url);
              }}
            >
              Søk på stillingen
            </Button>
          </Row>
        )}
      </Card>
    </>
  );
};

export default JobDescription;

// harkodet fargekode: #59C09C
